export default __webpack_public_path__ + "static/media/Tiger's Legguards of the Roaring Jungle.dd7a6b94.jpg";